import { TipoSolicitacaoPlaca } from "../../constants/tipoSolicitacaoPlaca";
import { useSolicitacoes } from "../../hooks/useSolicitacoes";
import { Filtros } from "../Filtros";
import { Listar } from "../Listar";

interface IProps {
  tipo: TipoSolicitacaoPlaca;
  onTotalAlterado: () => void;
}

export function Solicitacoes({ tipo, onTotalAlterado }: IProps) {
  const {
    solicitacoes,
    totalRegistros,
    carregando,
    limite,
    reiniciarPaginacao,
    aplicarFiltros,
    setPagina,
    mudarLimite,
    ordenar,
    recarregar,
    exportar,
    exportando,
    importarPlanilha,
    enviandoPlanilha,
    criarLote,
    criandoLote,
  } = useSolicitacoes(tipo);

  return (
    <>
      <Filtros onBuscar={aplicarFiltros} />
      <Listar
        solicitacoes={solicitacoes}
        totalRegistros={totalRegistros}
        carregando={carregando}
        limite={limite}
        reiniciarPaginacao={reiniciarPaginacao}
        onMudarPagina={setPagina}
        onMudarLimite={mudarLimite}
        onOrdenar={ordenar}
        onExportar={exportar}
        exportando={exportando}
        importarPlanilha={importarPlanilha}
        enviandoPlanilha={enviandoPlanilha}
        onTotalAlterado={onTotalAlterado}
        onMovidas={() => {
          recarregar();
          onTotalAlterado();
        }}
        criarLote={criarLote}
        criandoLote={criandoLote}
      />
    </>
  );
}
